// extracted by mini-css-extract-plugin
export default {"wrapper":"DatePickerRu_wrapper__2yn7N"};